import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardShow: false,
  userPreferences: null,
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardShow(state, action) {
      state.dashboardShow = action.payload;
    },
    setUserPreferences(state, action) {
      state.userPreferences = action.payload;
    }
  }
})

export const { setDashboardShow, setUserPreferences } = dashboardSlice.actions;
export default dashboardSlice.reducer;
